/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-09-08 15:22:30
 */
const state = { 
	nodeId: null,
  processTaskId: '',
};
//实时监听state值的变化(最新状态)
const getters = { 
	getnodeId(state) { 
		return state.nodeId
	},
	getProcessTaskId(state) { 
		return state.processTaskId
	},
};
//第一参数未默认参数
//同步，执行this.$store.commit('')
const mutations = {
	ChangenodeId(state, nodeId) { 
		state.nodeId=nodeId
	},
	setProcessTaskId: (state, data) => {
		state.processTaskId = data
	},
};
//异步，执行this.$store.dispatch('')
const actions = {
	ChangenodeId(context,nodeId) { 
		context.commit('ChangenodeId',nodeId);
	},
	setProcessTaskId(context,data) { 
		context.commit('setProcessTaskId',data);
	}	
};
export default {
		//namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
		state,
		getters,
		mutations,
		actions
}